export const TYPES = {
  SET_IS_LOADING: "SET_IS_LOADING",
  NEXT_STEP: "NEXT_STEP",
  PREV_STEP: "PREV_STEP",
};
